import { createContext } from 'react';
export const InvestPortfolioContext = createContext({});
